import type React from "react";
import { ReactComponent as Svg } from "./assets/phone.svg";
import * as styles from "./Icon.module.scss";

type PhoneProps = React.SVGProps<SVGSVGElement>;

export const Phone = ({ className, ...props }: PhoneProps) => (
  <Svg className={className ?? styles.base} {...props} />
);
